import React, { memo, useState } from 'react'
import {
    BrowserRouterProps as NativeBrowserRouterProperties,
    Router,
} from 'react-router-dom'

import { History } from 'history'

type BrowserRouterProperties = Omit<NativeBrowserRouterProperties, 'window'> & {
    history: History
}

export const BrowserRouter = memo(
    ({ history, ...properties }: Readonly<BrowserRouterProperties>) => {
        const [state, setState] = useState({
            action: history.action,
            location: history.location,
        })

        React.useLayoutEffect(() => history.listen(setState), [history])

        return (
            <Router
                {...properties}
                location={state.location}
                navigationType={state.action}
                navigator={history}
            />
        )
    },
)

BrowserRouter.displayName = 'BrowserRouter'
